import { Text } from '../../../components/general/Text';
import { VehicleConnectionIndicator } from '../../../components/general/VehicleConnectionIndicator';
import type { VehicleId } from '../../../types/gcs/vehicle';
import { getShortVehicleId } from '../../../utils/formatters';
import { SidePanelVehicleTelemetryTile } from './SidePanelTelemetryTile';
import VehicleStatusTile from './VehicleStatusTile';

interface SidePanelVehicleTileProps {
  gcsId: string;
  vehicleId: VehicleId;
  isSelected: boolean;
  onPress: () => void;
}

export const SidePanelVehicleTile = ({ gcsId, vehicleId, isSelected, onPress }: SidePanelVehicleTileProps) => {
  const vehicleLabel = getShortVehicleId(vehicleId);

  return (
    <li
      onClick={onPress}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = isSelected ? '#b2b2b2' : '#dfdfdf';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = isSelected ? '#e3e3e3' : '#ffffff';
      }}
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        gap: '8px',
        cursor: 'pointer',
        backgroundColor: isSelected ? '#e3e3e3' : '#ffffff'
      }}
    >
      <Text
        variant='body3-bold'
        style={{
          width: '32px',
          flexShrink: 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          textAlign: 'left'
        }}
      >
        {vehicleLabel}
      </Text>
      <VehicleStatusTile gcsId={gcsId} vehicleId={vehicleId} />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <VehicleConnectionIndicator gcsId={gcsId} vehicleId={vehicleId} />
      </div>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
        <SidePanelVehicleTelemetryTile gcsId={gcsId} vehicleId={vehicleId} />
      </div>
    </li>
  );
};
